/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_TextInput from "../components/BSL_TextInput";
import BSL_ControlContainer from "../components/BSL_ControlContainer";
import * as BSL_Common from "../components/BSL_CommonControls";
import { Chip, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import DoneIcon from "@material-ui/icons/Done";
import Autocomplete from "react-autocomplete";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import BSL_CheckBox from "../components/BSL_CheckBox";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    sl_row: {
        flex: 1,
        display: "flex",
        margin: "3px 0px",
        padding: "3px 0px",
        borderBottom: "1px dotted grey",
    },
    sl_row_header: {
        display: "flex",
        width: "100px",
    },
    sl_row_content: {
        flexWrap: "wrap",
        flex: "1",
    },
    sl_content: {
        display: "flex",
        flexDirectio: "column",
        flex: "1",
    },
    sl_chip: {
        color: theme.palette.primary.main,
    },
    pair_chip: {
        color: theme.palette.primary.main,
    },
    pair_header: {
        color: theme.palette.primary.main,
        fontSize: "14px",
        fontWeight: 600,
    },
}));

export function ReplaceAll(target, search, replacement) {
    return target.replace(new RegExp(search, "g"), replacement);
}
function GetPromptCode(key, prompt_codes_string) {
    var return_val = null;
    if (!prompt_codes_string) return null;
    // $.each(prompt_codes_string.match(/(?:[^\s"]+|"[^"]*")+/g), function (index, element) {

    prompt_codes_string.match(/(?:[^\s"]+|"[^"]*")+/g).forEach((element) => {
        var pair = element.split("=");
        if (pair[1] && pair[0] === key) {
            return_val = ReplaceAll(pair[1], '"', "");
        }
    });
    return return_val;
}

function GetPromptCodeKeys(prompt_codes_string) {
    var return_val = [];
    if (!prompt_codes_string) return null;

    prompt_codes_string.match(/(?:[^\s"]+|"[^"]*")+/g).forEach((element) => {
        var pair = element.split("=");
        return_val.push(pair[0]);
    });
    return return_val;
}

function SortObjectByKey(unordered) {
    return Object.keys(unordered)
        .sort()
        .reduce((obj, key) => {
            obj[key] = unordered[key];
            return obj;
        }, {});
}

function GetSLs(prompt_codes_string) {
    let sl_array = {};
    let stock_lengths = prompt_codes_string;
    if (!stock_lengths) stock_lengths = "";
    stock_lengths = stock_lengths.split("|");
    for (let sl of stock_lengths) {
        let length = sl.split("(")[0];
        let subgroup = sl?.split("(")?.[1]?.replace(")", "") ?? "";
        sl_array[length] = subgroup;
    }
    SortObjectByKey(sl_array);
    return sl_array;
}

export default function ManageProductListControlCodes(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { row, saveValue, onClose, pricefileDescSummary } = props;

    let control_codes_raw = row?.PromptTextCodes;

    const [stockLengths, setStockLengths] = React.useState(undefined);
    const [displayData, setDisplayData] = React.useState(control_codes_raw);
    const [pairPOAs, setPairPOAs] = React.useState(undefined);
    const [newPairPOA, setNewPairPOA] = React.useState("");
    const [newPairCode, setNewPairCode] = React.useState("");

    const [redirectPOAs, setRedirectPOAs] = React.useState(undefined);
    const [newRedirectPOA, setNewRedirectPOA] = React.useState("");
    const [newRedirectCode, setNewRedirectCode] = React.useState("");

    const [newSL, setNewSL] = React.useState("");
    const [newSLSubgroup, setNewSLSubgroup] = React.useState("");
    const [addSL, setAddSL] = React.useState(undefined);

    const [altIndex, setAltIndex] = React.useState(GetPromptCode("AltIndex", control_codes_raw));
    const [disableNesting, setDisableNesting] = React.useState(
        GetPromptCode("DisableNesting", control_codes_raw) === null
            ? 0
            : GetPromptCode("DisableNesting", control_codes_raw)
            ? 1
            : 0
    );
    const [reverseColourCode, setReverseColourCode] = React.useState(
        GetPromptCode("ReverseColCode", control_codes_raw) === null
            ? 0
            : GetPromptCode("ReverseColCode", control_codes_raw)
            ? 1
            : 0
    );

    const [desc, setDesc] = React.useState(GetPromptCode("Desc", control_codes_raw));
    const [lldDesc, setLLDDesc] = React.useState(GetPromptCode("LLDDesc", control_codes_raw));
    const [cdsDesc, setCDSDesc] = React.useState(GetPromptCode("CDSDesc", control_codes_raw));
    const [length, setLength] = React.useState(GetPromptCode("Length", control_codes_raw));
    const [maxLength, setMaxLength] = React.useState(GetPromptCode("MAX_LM", control_codes_raw));
    const [minLength, setMinLength] = React.useState(GetPromptCode("MIN_LM", control_codes_raw));
    const [drawing, setDrawing] = React.useState(GetPromptCode("Drawing", control_codes_raw));
    const [autocompleteOptions, setAutocomplateOptions] = React.useState(null);
    const [cutExtra, setCutExtra] = React.useState(GetPromptCode("CutExtra", control_codes_raw));
    const [extraLM, setExtraLM] = React.useState(GetPromptCode("ExtraLM", control_codes_raw));

    let valid_pitches_raw = GetPromptCode("@@", control_codes_raw);
    const [validPitches, setValidPitches] = React.useState(valid_pitches_raw ? valid_pitches_raw.split("|") : []);

    let disabled_raw = GetPromptCode("DISABLED", control_codes_raw);
    const [disabledPOAs, setDisabledPOAs] = React.useState(disabled_raw ? disabled_raw.split("|") : []);

    const [priceOverride, setPriceOverride] = React.useState(GetPromptCode("$$", control_codes_raw));

    let input_style = { padding: "0px", margin: "1px" };

    let keys = GetPromptCodeKeys(control_codes_raw);

    React.useEffect(() => {
        setDisplayData(getData());
    }, [
        stockLengths,
        pairPOAs,
        redirectPOAs,
        altIndex,
        desc,
        lldDesc,
        cdsDesc,
        length,
        priceOverride,
        validPitches,
        disabledPOAs,
        disableNesting,
        reverseColourCode,
        maxLength,
        minLength,
        cutExtra,
        extraLM,
    ]);

    const getData = () => {
        let data = "";
        if (length) data += (data ? " " : "") + "Length=" + length;
        if (maxLength) data += (data ? " " : "") + "MAX_LM=" + maxLength;
        if (minLength) data += (data ? " " : "") + "MIN_LM=" + minLength;
        if (cutExtra) data += (data ? " " : "") + "CutExtra=" + cutExtra;
        if (extraLM) data += (data ? " " : "") + "ExtraLM=" + extraLM;

        if (desc) data += (data ? " " : "") + 'Desc="' + desc + '"';
        if (lldDesc) data += (data ? " " : "") + 'LLDDesc="' + lldDesc + '"';
        if (cdsDesc) data += (data ? " " : "") + 'CDSDesc="' + cdsDesc + '"';
        if (priceOverride) data += (data ? " " : "") + "$$=" + priceOverride;
        if (altIndex) data += (data ? " " : "") + "AltIndex=" + altIndex;
        if (drawing) data += (data ? " " : "") + 'Drawing="' + drawing + '"';
        if (validPitches && validPitches.length > 0) {
            let pitch_data = "";
            for (let pitch of validPitches) {
                pitch_data += (pitch_data ? "|" : "") + pitch;
            }
            data += (data ? " @@=" : "@@=") + pitch_data;
        }
        if (disabledPOAs && disabledPOAs.length > 0) {
            let disPOAs = "";
            for (let poas of disabledPOAs) {
                disPOAs += (disPOAs ? "|" : "") + poas;
            }
            data += (data ? " DISABLED=" : "DISABLED=") + disPOAs;
        }
        if (disableNesting) data += (data ? " " : "") + "DisableNesting=1";
        if (reverseColourCode) data += (data ? " " : "") + "ReverseColCode=1";

        if (stockLengths && Object.keys(stockLengths).length > 0)
            for (let sl_poa in stockLengths) {
                let data_row = "";
                if (Object.keys(stockLengths[sl_poa]).length > 0)
                    for (let sl_length in stockLengths[sl_poa]) {
                        if (sl_length && stockLengths[sl_poa][sl_length])
                            data_row += (data_row ? "|" : "") + sl_length + "(" + stockLengths[sl_poa][sl_length] + ")";
                    }
                if (!data_row) continue;
                if (sl_poa === "ALL") data += (data ? " SL=" : "SL=") + data_row;
                else data += (data ? " SL_" + sl_poa + "=" : "SL_" + sl_poa + "=") + data_row;
            }

        if (pairPOAs && Object.keys(pairPOAs).length > 0)
            for (let pairPOA in pairPOAs) {
                if (!pairPOAs[pairPOA]) continue;
                if (pairPOA === "ALL") data += (data ? " PAIR=" : "PAIR=") + pairPOAs[pairPOA];
                else data += (data ? " PAIR_" + pairPOA + "=" : "PAIR_" + pairPOA + "=") + pairPOAs[pairPOA];
            }

        if (redirectPOAs && Object.keys(redirectPOAs).length > 0)
            for (let redirectPOA in redirectPOAs) {
                if (!redirectPOAs[redirectPOA]) continue;
                if (redirectPOA === "ALL") data += (data ? " REDIRECT=" : "REDIRECT=") + redirectPOAs[redirectPOA];
                else
                    data +=
                        (data ? " REDIRECT_" + redirectPOA + "=" : "REDIRECT_" + redirectPOA + "=") +
                        redirectPOAs[redirectPOA];
            }
        return data;
    };

    const saveData = () => {
        let data = getData();
        saveValue(row, "PromptTextCodes", data);
    };

    if (!autocompleteOptions) {
        let options = [];
        for (let option in pricefileDescSummary) {
            options.push(option + " - " + pricefileDescSummary[option]);
        }
        setAutocomplateOptions(options);
    }

    const LYSAGHT_POAs = ["LSB", "EMU", "NUN", "LAU", "GIL", "KEW"];
    const CENTENARY_POAs = ["MEN", "CAM", "MIN", "WAN"];

    let poaOptions = [];
    for (let option of LYSAGHT_POAs) {
        poaOptions.push(option);
    }
    for (let option of CENTENARY_POAs) {
        poaOptions.push(option);
    }

    if (stockLengths === undefined) {
        let new_stockLengths = {};
        let sl_all = GetSLs(GetPromptCode("SL", control_codes_raw));
        new_stockLengths["ALL"] = sl_all;

        if (keys)
            for (let key of keys) {
                if (key.startsWith("SL_")) {
                    let sl = GetSLs(GetPromptCode(key, control_codes_raw));
                    new_stockLengths[key.replace("SL_", "")] = sl;
                }
            }
        setStockLengths(new_stockLengths);
    }

    if (pairPOAs === undefined) {
        let new_pairPOAs = {};
        let pair_all = GetPromptCode("PAIR", control_codes_raw);
        new_pairPOAs["ALL"] = pair_all;
        if (keys)
            for (let key of keys) {
                if (key.startsWith("PAIR_")) {
                    let pair = GetPromptCode(key, control_codes_raw);
                    new_pairPOAs[key.replace("PAIR_", "")] = pair;
                }
            }
        
        setPairPOAs(new_pairPOAs);
    }

    if (redirectPOAs === undefined) {
        let new_redirectPOAs = {};
        let redirect_all = GetPromptCode("REDIRECT", control_codes_raw);
        new_redirectPOAs["ALL"] = redirect_all;
        if (keys)
            for (let key of keys) {
                if (key.startsWith("REDIRECT_")) {
                    let redirect = GetPromptCode(key, control_codes_raw);
                    new_redirectPOAs[key.replace("REDIRECT_", "")] = redirect;
                }
            }
        
        setRedirectPOAs(new_redirectPOAs);
    }

    const handleDeleteRow = (poa) => {
        let new_stockLengths = { ...stockLengths };
        if (new_stockLengths[poa]) {
            if (poa === "ALL") new_stockLengths[poa] = {};
            else delete new_stockLengths[poa];
            setStockLengths(new_stockLengths);
            setNewSL("");
            setNewSLSubgroup("");
            setAddSL("");
        }
    };
    const handleDelete = (poa, length) => {
        let new_stockLengths = { ...stockLengths };
        if (new_stockLengths[poa][length]) {
            delete new_stockLengths[poa][length];
            setStockLengths(new_stockLengths);
            setNewSL("");
            setNewSLSubgroup("");
            setAddSL("");
        }
    };
    const handleAdd = (poa, length = null, subgroup = null) => {
        if (length === null && newSL) length = newSL;
        if (subgroup === null && newSLSubgroup) subgroup = newSLSubgroup;
        if (!length) {
            alert("add a new length");
            return;
        }
        if (!subgroup) {
            alert("add a subgroup");
            return;
        }
        let new_stockLengths = { ...stockLengths };
        new_stockLengths[poa][length] = subgroup;
        setStockLengths(new_stockLengths);
        setNewSL("");
        setNewSLSubgroup("");
        setAddSL("");
    };

    const addSLPOA = (poa) => {
        if (!poa) return;
        let new_stockLengths = { ...stockLengths };
        if (new_stockLengths[poa]) {
            alert("POA '" + poa + "' already exists");
            return;
        } else {
            new_stockLengths[poa] = {};
            setStockLengths(new_stockLengths);
            setNewSL("");
            setNewSLSubgroup("");
            setAddSL("");
        }
    };

    const handleAddPairPOA = (poa, code) => {
        if (!poa) {
            alert("add a new pair POA");
            return;
        }
        if (!code) {
            // alert("add a pair code");
            return;
        }
        let new_pairPOAs = { ...pairPOAs };
        new_pairPOAs[poa] = code;
        setPairPOAs(new_pairPOAs);
        setNewPairPOA("");
        setNewPairCode("");
    };

    const handleDeletePair = (poa) => {
        let new_pairPOAs = { ...pairPOAs };
        if (new_pairPOAs[poa]) {
            delete new_pairPOAs[poa];
            setPairPOAs(new_pairPOAs);
            setNewPairPOA("");
            setNewPairCode("");
        }
    };

    const handleAddRedirectPOA = (poa, code) => {
        if (!poa) {
            alert("add a new redirect POA");
            return;
        }
        if (!code) {
            // alert("add a redirect code");
            return;
        }
        let new_redirectPOAs = { ...redirectPOAs };
        new_redirectPOAs[poa] = code;
        setRedirectPOAs(new_redirectPOAs);
        setNewRedirectPOA("");
        setNewRedirectCode("");
    };

    const handleDeleteRedirect = (poa) => {
        let new_redirectPOAs = { ...redirectPOAs };
        if (new_redirectPOAs[poa]) {
            delete new_redirectPOAs[poa];
            setRedirectPOAs(new_redirectPOAs);
            setNewRedirectPOA("");
            setNewRedirectCode("");
        }
    };

    let stock_length_rows = [];
    if (stockLengths) {
        for (let sl_poa in stockLengths) {
            let chips = [];
            for (let sl_key in stockLengths[sl_poa]) {
                let length = sl_key;
                let subgroup = stockLengths[sl_poa][sl_key] ?? row?.SubGroup;
                if (length)
                    chips.push(
                        <Chip
                            label={
                                <>
                                    <b>{length}mm</b>
                                    <br />
                                    sub:{subgroup}
                                </>
                            }
                            onDelete={() => handleDelete(sl_poa, length)}
                            className={classes.sl_chip}
                        />
                    );
            }

            chips.push(
                <Chip
                    label={
                        addSL === sl_poa && (
                            <BSL_Common.SectionRow>
                                <BSL_TextInput
                                    value={newSL}
                                    placeholder="length"
                                    tight
                                    min={0}
                                    max={999999}
                                    autoFocus
                                    style={{ flex: "none", width: "80px" }}
                                    endAdornment={"mm"}
                                    onClick={(e) => {}}
                                    onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                    InputProps={{
                                        style: { fontSize: "80%" },
                                    }}
                                    onBlur={(val) => setNewSL(val)}
                                />
                                <BSL_TextInput
                                    value={newSLSubgroup}
                                    placeholder="subgroup"
                                    preValidate="numbersOnly"
                                    tight
                                    style={{ flex: "none", width: "80px" }}
                                    onClick={(e) => {}}
                                    onEnter={(e) => handleAdd(sl_poa, null, e.target.value)}
                                    InputProps={{
                                        style: { fontSize: "80%" },
                                    }}
                                    onBlur={(val) => setNewSLSubgroup(val)}
                                />
                            </BSL_Common.SectionRow>
                        )
                    }
                    onDelete={() => {
                        if (!addSL || addSL != sl_poa) {
                            setAddSL(sl_poa);
                        } else if (addSL === sl_poa) {
                            handleAdd(sl_poa);
                        }
                    }}
                    style={{ background: "#c7c7c7" }}
                    deleteIcon={addSL === sl_poa ? <DoneIcon /> : <AddIcon />}
                />
            );

            stock_length_rows.push(
                <div className={classes.sl_row}>
                    <div className={classes.sl_row_header}>
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                                handleDeleteRow(sl_poa);
                            }}
                        >
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                        <BSL_TextInput
                            value={sl_poa}
                            tight
                            allCaps
                            disabled={sl_poa === "ALL" ? true : false}
                            style={input_style}
                            onClick={(e) => {}}
                            // onBlur={(val) => updateMarkup(key, "DisplayName", val)}
                        />
                    </div>
                    <div className={classes.sl_row_content}>{chips}</div>
                </div>
            );
        }
    }

    let pair_items = [];

    if (pairPOAs) {
        for (let pair in pairPOAs) {
            pair_items.push(
                <Chip
                    label={
                        <BSL_Common.SectionRow
                            style={{
                                alignItems: "center",
                            }}
                        >
                            <span className={classes.pair_header}>{pair}:</span>
                            <Autocomplete
                                items={autocompleteOptions}
                                shouldItemRender={(item, value) =>
                                    value && value.length > 2
                                        ? item.toLowerCase().indexOf(value.toLowerCase()) > -1
                                        : false
                                }
                                getItemValue={(item) => item.split("-")[0].trim()}
                                autoHighlight={false}
                                renderItem={(item, highlighted) => (
                                    <div
                                        key={item.id}
                                        style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                    >
                                        {item}
                                    </div>
                                )}
                                menuStyle={{
                                    zIndex: "999999",
                                    position: "absolute",
                                    backgroundColor: "whitesmoke",
                                    boxShadow: "1px 1px 4px",
                                    fontSize: "12px",
                                    left: "auto",
                                    top: "auto",
                                    marginLeft: "9px",
                                    marginTop: "0px",
                                    lineHeight: 1.4,
                                }}
                                inputProps={{
                                    style: {
                                        font: "200 12px Univers45",
                                        width: "95%",
                                        padding: "4px 0px 4px 8px !important",
                                    },
                                }}
                                renderInput={(props) => {
                                    return (
                                        <BSL_TextInput
                                            value={pairPOAs?.[pair]}
                                            placeholder="Pair Code"
                                            preValidate="alpha"
                                            tight
                                            allCaps
                                            style={{ flex: "none", width: "120px" }}
                                            onClick={(e) => {}}
                                            // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                            InputProps={{
                                                style: { fontSize: "80%" },
                                                ...props,
                                            }}
                                            onEnter={(e) => handleAddPairPOA(pair, e.target.value)}
                                            onBlur={(val) => handleAddPairPOA(pair, val)}
                                        />
                                    );
                                }}
                                value={pairPOAs?.[pair]}
                                onChange={(e) => handleAddPairPOA(pair, e.target.value)}
                                onSelect={(val) => handleAddPairPOA(pair, val)}
                            />

                            {/* <BSL_TextInput
                                value={pairPOAs?.[pair]}
                                placeholder="Pair Code"
                                tight
                                allCaps
                                style={{ flex: "none", width: "120px" }}
                                onClick={(e) => {}}
                                // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                InputProps={{
                                    style: { fontSize: "80%" },
                                }}
                                onEnter={(e) => handleAddPairPOA(pair, e.target.value)}
                                onBlur={(val) => handleAddPairPOA(pair, val)}
                            /> */}
                        </BSL_Common.SectionRow>
                    }
                    onDelete={pair === "ALL" ? null : () => handleDeletePair(pair)}
                    className={classes.pair_chip}
                />
            );
        }
    }

    pair_items.push(
        <Chip
            label={
                <BSL_Common.SectionRow>
                    {/* <BSL_TextInput
                        value={newPairPOA}
                        placeholder="POA"
                        preValidate="alpha"
                        allCaps
                        tight
                        style={{ flex: "none", width: "80px" }}
                        InputProps={{
                            style: { fontSize: "80%" },
                        }}
                        onEnter={(e) => handleAddPairPOA(e.target.value, newPairCode)}
                        onBlur={(val) => setNewPairPOA(val)}
                    /> */}

                    <Autocomplete
                        items={poaOptions}
                        shouldItemRender={(item, value) => (value ? true : true)}
                        getItemValue={(item) => item}
                        autoHighlight={false}
                        renderItem={(item, highlighted) => (
                            <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                {item}
                            </div>
                        )}
                        menuStyle={{
                            zIndex: "999999",
                            position: "absolute",
                            backgroundColor: "whitesmoke",
                            boxShadow: "1px 1px 4px",
                            fontSize: "12px",
                            left: "auto",
                            top: "auto",
                            marginLeft: "9px",
                            marginTop: "0px",
                            lineHeight: 1.4,
                        }}
                        inputProps={{
                            style: {
                                font: "200 12px Univers45",
                                width: "95%",
                                padding: "4px 0px 4px 8px !important",
                            },
                        }}
                        renderInput={(props) => {
                            return (
                                <BSL_TextInput
                                    value={newPairPOA}
                                    placeholder="POA"
                                    preValidate="alpha"
                                    tight
                                    allCaps
                                    style={{ flex: "none", width: "80px" }}
                                    onClick={(e) => {}}
                                    // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                    InputProps={{
                                        style: { fontSize: "80%" },
                                        ...props,
                                    }}
                                    onEnter={(e) => setNewPairPOA(e.target.value)}
                                    onBlur={(val) => setNewPairPOA(val)}
                                />
                            );
                        }}
                        value={newPairPOA}
                        onChange={(e) => setNewPairPOA(e.target.value)}
                        onSelect={(val) => setNewPairPOA(val)}
                    />

                    {/* <BSL_TextInput
                        value={newPairCode}
                        placeholder="Pair Code"
                        allCaps
                        tight
                        style={{ flex: "none", width: "80px" }}
                        InputProps={{
                            style: { fontSize: "80%" },
                        }}
                        onEnter={(e) => handleAddPairPOA(newPairPOA, e.target.value)}
                        onBlur={(val) => setNewPairCode(val)}
                    /> */}
                    <Autocomplete
                        items={autocompleteOptions}
                        shouldItemRender={(item, value) =>
                            value && value.length > 2 ? item.toLowerCase().indexOf(value.toLowerCase()) > -1 : false
                        }
                        getItemValue={(item) => item.split("-")[0].trim()}
                        autoHighlight={false}
                        renderItem={(item, highlighted) => (
                            <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                {item}
                            </div>
                        )}
                        menuStyle={{
                            zIndex: "999999",
                            position: "absolute",
                            backgroundColor: "whitesmoke",
                            boxShadow: "1px 1px 4px",
                            fontSize: "12px",
                            left: "auto",
                            top: "auto",
                            marginLeft: "9px",
                            marginTop: "0px",
                            lineHeight: 1.4,
                        }}
                        inputProps={{
                            style: {
                                font: "200 12px Univers45",
                                width: "95%",
                                padding: "4px 0px 4px 8px !important",
                            },
                        }}
                        renderInput={(props) => {
                            return (
                                <BSL_TextInput
                                    value={newPairCode}
                                    placeholder="Pair Code"
                                    tight
                                    allCaps
                                    style={{ flex: "none", width: "80px" }}
                                    onClick={(e) => {}}
                                    // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                    InputProps={{
                                        style: { fontSize: "80%" },
                                        ...props,
                                    }}
                                    onEnter={(e) => handleAddPairPOA(newPairPOA, e.target.value)}
                                    onBlur={(val) => setNewPairCode(val)}
                                />
                            );
                        }}
                        value={newPairCode}
                        onChange={(e) => setNewPairCode(e.target.value)}
                        onSelect={(val) => handleAddPairPOA(newPairPOA, val)}
                    />
                </BSL_Common.SectionRow>
            }
            onDelete={() => {
                handleAddPairPOA(newPairPOA, newPairCode);
            }}
            style={{ background: "#c7c7c7" }}
            deleteIcon={<DoneIcon />}
        />
    );

    let redirect_items = [];

    if (redirectPOAs) {
        for (let redirect in redirectPOAs) {
            redirect_items.push(
                <Chip
                    label={
                        <BSL_Common.SectionRow
                            style={{
                                alignItems: "center",
                            }}
                        >
                            <span className={classes.pair_header}>{redirect}:</span>

                            <Autocomplete
                                items={autocompleteOptions}
                                shouldItemRender={(item, value) =>
                                    value && value.length > 2
                                        ? item.toLowerCase().indexOf(value.toLowerCase()) > -1
                                        : false
                                }
                                getItemValue={(item) => item.split("-")[0].trim()}
                                autoHighlight={false}
                                renderItem={(item, highlighted) => (
                                    <div
                                        key={item.id}
                                        style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                    >
                                        {item}
                                    </div>
                                )}
                                menuStyle={{
                                    zIndex: "999999",
                                    position: "absolute",
                                    backgroundColor: "whitesmoke",
                                    boxShadow: "1px 1px 4px",
                                    fontSize: "12px",
                                    left: "auto",
                                    top: "auto",
                                    marginLeft: "9px",
                                    marginTop: "0px",
                                    lineHeight: 1.4,
                                }}
                                inputProps={{
                                    style: {
                                        font: "200 12px Univers45",
                                        width: "95%",
                                        padding: "4px 0px 4px 8px !important",
                                    },
                                }}
                                renderInput={(props) => {
                                    return (
                                        <BSL_TextInput
                                            value={redirectPOAs?.[redirect]}
                                            placeholder="Redirect Code"
                                            tight
                                            allCaps
                                            style={{ flex: "none", width: "120px" }}
                                            onClick={(e) => {}}
                                            // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                            InputProps={{
                                                style: { fontSize: "80%" },
                                                ...props,
                                            }}
                                            onEnter={(e) => handleAddRedirectPOA(redirect, e.target.value)}
                                            onBlur={(val) => handleAddRedirectPOA(redirect, val)}
                                        />
                                    );
                                }}
                                value={redirectPOAs?.[redirect]}
                                onChange={(e) => handleAddRedirectPOA(redirect, e.target.value)}
                                onSelect={(val) => handleAddRedirectPOA(redirect, val)}
                            />

                            {/* <BSL_TextInput
                                value={redirectPOAs?.[redirect]}
                                tight
                                allCaps
                                style={{ flex: "none", width: "120px" }}
                                onClick={(e) => {}}
                                // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                InputProps={{
                                    style: { fontSize: "80%" },
                                }}
                                onEnter={(e) => handleAddRedirectPOA(redirect, e.target.value)}
                                onBlur={(val) => handleAddRedirectPOA(redirect, val)}
                            /> */}
                        </BSL_Common.SectionRow>
                    }
                    onDelete={redirect === "ALL" ? null : () => handleDeleteRedirect(redirect)}
                    className={classes.pair_chip}
                />
            );
        }
    }

    let redirect_options = [];
    for (let item of poaOptions) {
        redirect_options.push({
            Display: "POA:" + item,
            Key: item,
        });
    }
    redirect_options.push({
        Display: "DOUBLE SIDED",
        Key: "DOUBLE_SIDED",
    });

    redirect_items.push(
        <Chip
            label={
                <BSL_Common.SectionRow>
                    {/* <BSL_TextInput
                        value={newRedirectPOA}
                        placeholder="POA"
                        preValidate="alpha"
                        allCaps
                        tight
                        style={{ flex: "none", width: "80px" }}
                        InputProps={{
                            style: { fontSize: "80%" },
                        }}
                        onEnter={(e) => handleAddRedirectPOA(e.target.value, newRedirectCode)}
                        onBlur={(val) => setNewRedirectPOA(val)}
                    /> */}

                    <Autocomplete
                        items={redirect_options}
                        shouldItemRender={(item, value) => (value ? true : true)}
                        getItemValue={(item) => item.Key}
                        autoHighlight={false}
                        renderItem={(item, highlighted) => (
                            <div key={item.Key} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                {item.Display}
                            </div>
                        )}
                        menuStyle={{
                            zIndex: "999999",
                            position: "absolute",
                            backgroundColor: "whitesmoke",
                            boxShadow: "1px 1px 4px",
                            fontSize: "12px",
                            left: "auto",
                            top: "auto",
                            marginLeft: "9px",
                            marginTop: "0px",
                            lineHeight: 1.4,
                        }}
                        inputProps={{
                            style: {
                                font: "200 12px Univers45",
                                width: "95%",
                                padding: "4px 0px 4px 8px !important",
                            },
                        }}
                        renderInput={(props) => {
                            return (
                                <BSL_TextInput
                                    value={newRedirectPOA}
                                    placeholder="TYPE"
                                    preValidate="alpha"
                                    tight
                                    allCaps
                                    style={{ flex: "none", width: "80px" }}
                                    onClick={(e) => {}}
                                    // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                    InputProps={{
                                        style: { fontSize: "80%" },
                                        ...props,
                                    }}
                                    onEnter={(e) => setNewRedirectPOA(e.target.value)}
                                    onBlur={(val) => setNewRedirectPOA(val)}
                                />
                            );
                        }}
                        value={newRedirectPOA}
                        onChange={(e) => setNewRedirectPOA(e.target.value)}
                        onSelect={(val) => setNewRedirectPOA(val)}
                    />

                    {/* <BSL_TextInput
                        value={newRedirectCode}
                        placeholder="Redirect Code"
                        allCaps
                        tight
                        style={{ flex: "none", width: "80px" }}
                        InputProps={{
                            style: { fontSize: "80%" },
                        }}
                        onEnter={(e) => handleAddRedirectPOA(newRedirectPOA, e.target.value)}
                        onBlur={(val) => setNewRedirectCode(val)}
                    /> */}
                    <Autocomplete
                        items={autocompleteOptions}
                        shouldItemRender={(item, value) =>
                            value && value.length > 2 ? item.toLowerCase().indexOf(value.toLowerCase()) > -1 : false
                        }
                        getItemValue={(item) => item.split("-")[0].trim()}
                        autoHighlight={false}
                        renderItem={(item, highlighted) => (
                            <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                {item}
                            </div>
                        )}
                        menuStyle={{
                            zIndex: "999999",
                            position: "absolute",
                            backgroundColor: "whitesmoke",
                            boxShadow: "1px 1px 4px",
                            fontSize: "12px",
                            left: "auto",
                            top: "auto",
                            marginLeft: "9px",
                            marginTop: "0px",
                            lineHeight: 1.4,
                        }}
                        inputProps={{
                            style: {
                                font: "200 12px Univers45",
                                width: "95%",
                                padding: "24px 0px 4px 8px !important",
                            },
                        }}
                        renderInput={(props) => {
                            return (
                                <BSL_TextInput
                                    value={newRedirectCode}
                                    placeholder="Redirect Code"
                                    tight
                                    allCaps
                                    style={{ flex: "none", width: "80px" }}
                                    onClick={(e) => {}}
                                    // onEnter={(e) => handleAdd(sl_poa, e.target.value)}
                                    InputProps={{
                                        style: { fontSize: "80%" },
                                        ...props,
                                    }}
                                    onEnter={(e) => handleAddRedirectPOA(newRedirectPOA, e.target.value)}
                                    onBlur={(val) => setNewRedirectCode(val)}
                                />
                            );
                        }}
                        value={newRedirectCode}
                        onChange={(e) => setNewRedirectCode(e.target.value)}
                        onSelect={(val) => handleAddRedirectPOA(newRedirectPOA, val)}
                    />
                </BSL_Common.SectionRow>
            }
            onDelete={() => {
                handleAddRedirectPOA(newRedirectPOA, newRedirectCode);
            }}
            style={{ background: "#c7c7c7" }}
            deleteIcon={<DoneIcon />}
        />
    );

    return (
        <BSL_Dialog
            title={"Edit Control Codes for " + row?.["ProductDescription"]}
            open={true}
            button1Text="Update"
            button1Click={() => {
                saveData();
            }}
            button2Text="Cancel"
            button2Click={onClose}
            style={{ maxWidth: "initial" }}
            fullWidth={true}
            maxWidth={"xl"}
        >
            <div
                style={{
                    backgroundColor: "beige",
                    fontFamily: "monospace",
                    padding: "10px",
                    borderRadius: "9px",
                    color: "#444444",
                }}
            >
                {displayData}
            </div>
            <BSL_Common.SectionRow>
                {/* <BSL_Common.SectionColumn
                    style={{
                        maxWidth: "150px",
                    }}
                > */}
                <BSL_TextInput
                    label={"Length"}
                    value={length}
                    tight={true}
                    min={0}
                    max={99999}
                    style={{
                        maxWidth: "145px",
                        flex: "none",
                        color: "white",
                    }}
                    onEnter={(e) => setLength(e.target.value)}
                    onChange={(value) => setLength(value)}
                    endAdornment={"mm"}
                    helperText={
                        "Length in mm... (where CAD system gives a length for this item, the BOM will tally the QTY based on the length); eg; Length=3000 ... where system length=7500, will return Qty=3"
                    }
                />
                <BSL_TextInput
                    label={"Min Length (LM)"}
                    value={minLength}
                    tight={true}
                    min={0}
                    max={99999}
                    style={{
                        maxWidth: "145px",
                        flex: "none",
                        color: "white",
                    }}
                    onEnter={(e) => setMinLength(e.target.value)}
                    onChange={(value) => setMinLength(value)}
                    endAdornment={"mm"}
                    helperText={
                        "Min Length in mm... (where CAD system gives a length less than this, the length will be adjusted to the min); eg; Min Length=3000 ... where system length=1200, will return Length=3000"
                    }
                />
                {/* </BSL_Common.SectionColumn>
                <BSL_Common.SectionColumn
                    style={{
                        maxWidth: "150px",
                    }}
                > */}
                <BSL_TextInput
                    label={"Max Length (LM)"}
                    value={maxLength}
                    tight={true}
                    min={0}
                    max={99999}
                    style={{
                        maxWidth: "145px",
                        flex: "none",
                        color: "white",
                    }}
                    onEnter={(e) => setMaxLength(e.target.value)}
                    onChange={(value) => setMaxLength(value)}
                    endAdornment={"mm"}
                    helperText={
                        "Max Length in mm... (where CAD system or user gives a length greater than this, a warning is given in the BOM that the length has been exceeded. for Back Channels (default: 9000), Gutters (default: 8000) and Flashings (default: 6100), this is the splicing length)"
                    }
                />
                <BSL_TextInput
                    label={"Splice Cut Extra"}
                    value={cutExtra}
                    tight={true}
                    min={0}
                    max={99999}
                    style={{
                        maxWidth: "145px",
                        flex: "none",
                        color: "white",
                    }}
                    onEnter={(e) => setCutExtra(e.target.value)}
                    onChange={(value) => setCutExtra(value)}
                    endAdornment={"mm"}
                    helperText={
                        "For Back Channels, Gutters and Flashing, when item is spliced by max length, add this extra to each length. The system default will be 200 if this is not set."
                    }
                />
                <BSL_TextInput
                    label={"Extra LM Allowance"}
                    value={extraLM}
                    tight={true}
                    min={0}
                    max={99999}
                    style={{
                        maxWidth: "145px",
                        flex: "none",
                        color: "white",
                    }}
                    onEnter={(e) => setExtraLM(e.target.value)}
                    onChange={(value) => setExtraLM(value)}
                    endAdornment={"mm"}
                    helperText={
                        "For each of this item, an extra of XXmm will be added. Default for Back Channels (default: 100), Gutters (default: 100) and Flashings (default: 200) and 0mm for all other categories "
                    }
                />
                {/* </BSL_Common.SectionColumn> */}
                {/* <BSL_Common.SectionColumn> */}
                <BSL_TextInput
                    label={"Ancillary Description"}
                    style={{ color: "white" }}
                    value={desc}
                    tight={true}
                    onEnter={(e) => setDesc(e.target.value)}
                    onChange={(value) => setDesc(value)}
                    helperText={
                        "A Short/abbreviated description, used in the BOM, particularly for ancillary item. ; eg; 'Short Name'"
                    }
                />
                {/* <BSL_TextInput
                        label={"Lysaght Description Override"}
                        style={{ color: "white" }}
                        value={lldDesc}
                        tight={true}
                        onEnter={(e) => setLLDDesc(e.target.value)}
                        onChange={(value) => setLLDDesc(value)}
                        // helperText={
                        //     "A Short/abbreviated description, used in the BOM, particularly for ancillary item. ; eg; 'Short Name'"
                        // }
                    />
                    <BSL_TextInput
                        label={"Centenary Description Override"}
                        style={{ color: "white" }}
                        value={cdsDesc}
                        tight={true}
                        onEnter={(e) => setCDSDesc(e.target.value)}
                        onChange={(value) => setCDSDesc(value)}
                        // helperText={
                        //     "A Short/abbreviated description, used in the BOM, particularly for ancillary item. ; eg; 'Short Name'"
                        // }
                    /> */}
                {/* </BSL_Common.SectionColumn> */}
                <BSL_TextInput
                    label={"Price Override"}
                    value={priceOverride}
                    tight={true}
                    onEnter={(e) => setPriceOverride(e.target.value)}
                    onChange={(value) => setPriceOverride(value)}
                    startAdornment={"$"}
                    style={{
                        width: "102px",
                        flex: "none",
                        color: "white",
                    }}
                    helperText={
                        "Fixed price to charge regardless of markups. eg; $$=0.01 -> always charge 1 cent ... Can be appended with LM for price per LM eg; $$=1.00LM -> charged $1 per LM"
                    }
                />
                <BSL_TextInput
                    label={"AltIndex"}
                    style={{ color: "white" }}
                    value={altIndex}
                    tight={true}
                    onEnter={(e) => setAltIndex(e.target.value)}
                    onChange={(value) => setAltIndex(value)}
                    helperText={
                        "Alternative Index codes that this item can be picked up with other than the primary Index code; eg; CBNW10150G"
                    }
                />
                {/* <BSL_TextInput
                    label={"Drawing"}
                    style={{ color: "white" }}
                    value={drawing}
                    tight={true}
                    onEnter={(e) => setDrawing(e.target.value)}
                    onChange={(value) => setDrawing(value)}
                    helperText={
                        "A PDF filename associated which will automatically be added to the Job Print Pack if this item is ordered. File must be in Azure Blob Storage."
                    }
                /> */}
                <SegmentedButtonGroup
                    label="Valid Pitches"
                    tight
                    exclusive={false}
                    value={validPitches}
                    items={["1", "2", "5", "10", "15", "20", "22.5", "25", "30"]}
                    // items={[
                    //     { Key: "1", Display: "1°" },
                    //     { Key: "2", Display: "2°" },
                    //     { Key: "5", Display: "5°" },
                    //     { Key: "10", Display: "10°" },
                    //     { Key: "15", Display: "15°" },
                    //     { Key: "20", Display: "20°" },
                    //     { Key: "22.5", Display: "22.5°" },
                    //     { Key: "25", Display: "25°" },
                    //     { Key: "30", Display: "30°" },
                    // ]}
                    onChange={(e, val) => {
                        setValidPitches(
                            val.sort((a, b) => {
                                if (Number(a) < Number(b)) return -1;
                                if (Number(a) > Number(b)) return 1;
                                return 0;
                            })
                        );

                        // if (validPitches.includes(val)) {
                        //     const filteredItems = validPitches.filter((item) => item !== val);
                        //     setValidPitches(
                        //         filteredItems.sort((a, b) => {
                        //             if (Number(a) < Number(b)) return -1;
                        //             if (Number(a) > Number(b)) return 1;
                        //             return 0;
                        //         })
                        //     );
                        // } else {
                        //     let new_array = [...validPitches];
                        //     new_array.push(val);
                        //     setValidPitches(
                        //         new_array.sort((a, b) => {
                        //             if (Number(a) < Number(b)) return -1;
                        //             if (Number(a) > Number(b)) return 1;
                        //             return 0;
                        //         })
                        //     );
                        // }
                    }}
                    helperText={
                        "Valid pitches for this item, only for items that have '@@' in the code of description to replace. Leave blank to allow any pitch."
                    }
                />
                <SegmentedButtonGroup
                    label="Disabled POAs"
                    tight
                    exclusive={false}
                    value={disabledPOAs}
                    items={["LSB", "EMU", "NUN", "LAU", "GIL", "KEW", "MEN", "MAR", "GAW", "NOA", "CAM", "MIN", "WAN"]}
                    onChange={(e, val) => {
                        // alert(val);
                        setDisabledPOAs(val);
                        // if (disabledPOAs.includes(val)) {
                        //     const filteredItems = disabledPOAs.filter((item) => item !== val);
                        //     setDisabledPOAs(filteredItems);
                        // } else {
                        //     let new_array = [...disabledPOAs];
                        //     new_array.push(val);
                        //     setDisabledPOAs(new_array);
                        // }
                    }}
                    helperText={
                        "POA's where this item should not display in the BOM as a selectable item AND will price with an ERROR if in the system/order list"
                    }
                />
                <BSL_CheckBox
                    tight
                    checked={reverseColourCode}
                    returnInt
                    label="Reverse Colour Code"
                    onChange={(val) => setReverseColourCode(val)}
                    helperText={
                        "If selected and colour code has 4 characters, the last 2 become the first two for Lyves Code Output... eg; CCPB = PBCC"
                    }
                />
            </BSL_Common.SectionRow>

            <BSL_ControlContainer label={"Stock Lengths"} style={{ color: "white" }} tight={true}>
                {stock_length_rows}

                <BSL_TextInput
                    value={""}
                    placeholder="POA"
                    allCaps
                    tight
                    autoFocus
                    style={{ width: "300px" }} // allows helperText to not wrap
                    textFieldStyle={{ width: "80px" }} // but still have text field not too big
                    InputProps={{
                        style: { width: "80px" },
                    }}
                    helperText={"Add a new POA specific set of stock lengths."}
                    onBlur={(val) => addSLPOA(val)}
                />
            </BSL_ControlContainer>

            <BSL_CheckBox
                tight
                checked={disableNesting}
                returnInt
                label="Disable Stock Lengths Nesting"
                onChange={(val) => setDisableNesting(val)}
                helperText={
                    "If there are stock lengths, and the length required exceeds the longest stock length, rather than splicing and nesting the item, it will be added into the BOM in its full length and an error will be generated in the BOM warning the user the item is not priced."
                }
            />

            <BSL_ControlContainer
                label={"Pair Codes"}
                style={{ color: "white" }}
                tight={true}
                helperText={
                    "Item pairing. This groups all items that share a pair code, and will be REPLACED with the pair code item to the QTY equal to the highest qty of all the items that share a pair code. This can be multiple items. (Initially created to cater for paired gutter stop ends).eg; PAIR=QSEP"
                }
            >
                {pair_items}
            </BSL_ControlContainer>

            <BSL_ControlContainer
                label={"Redirect Codes"}
                style={{ color: "white" }}
                tight={true}
                helperText={
                    "Item Redirect. This item will be replaced in the BOM with the redirect code. This can also be done under specific POA's only using a POA redirect code. POA specific redirect take precendent over overall redirects. Using overall redirects is generally not recommended, codes should generally be changed higher up in the process (CAD/Material/Offering File)"
                }
            >
                {redirect_items}
            </BSL_ControlContainer>
        </BSL_Dialog>
    );
}
